import { isDefined } from "@clipboard-health/util-ts";
import { Divider, Text } from "@src/appV2/redesign/system/ui-components";
import { isEmpty } from "lodash";
import { Fragment } from "react";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { formatTagsByGroup } from "../../../utils";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface PlacementTagsSectionProps {
  placement: PlacementWithDetails;
}

export function PlacementTagsSection(props: PlacementTagsSectionProps) {
  const { placement } = props;

  if (!isDefined(placement.tags) || isEmpty(placement.tags)) {
    return null;
  }

  const tagGroups = formatTagsByGroup(placement.tags, {
    sortTags: true,
    includeValidTagsFlag: true,
  });

  return (
    <>
      {tagGroups.map((group) => (
        <Fragment key={group.groupLabel}>
          <Divider color="primary" />
          <PlacementSectionTemplate title={group.groupLabel} iconType="patients">
            <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
              {group.formattedTags}
            </Text>
          </PlacementSectionTemplate>
        </Fragment>
      ))}
    </>
  );
}
